/***** User end points ******/
export const Login_USER_API = "/user/auth/login";
export const Login_OTP_VERIFY_API = "/user/auth/verify-otp";
export const VERIFY_SESSION_TOKEN_API = "/user/auth/verifysessiontoken";
export const DELETE_SESSION_TOKEN_API = "/user/auth/deletesessiontoken";
export const USER_UPDATE_PASSWORD = "/user/change-password/";
export const Set_USER_PASSWORD = "/user/auth/set-password";
export const ADD_USER = "/user/auth/register";
export const VERIFY_EMAIL = "/user/auth/forgot-password";
export const RESET_PASSWORD = "/user/auth/reset-password";
export const GET_PROFILE_DATA = "/user/";
export const PHONE_OTP_VERIFY = "/user/verify-phone/";
export const RESEND_OTP = "/user/auth/resend-otp";
export const GET_USER_ROLES = "/user/role";
export const CHECK_INVITATION_TOKEN = "/user/auth/check-invitation";
export const GET_COUNTRY_CODE = "/user/country-list";

/***** Customer end points ******/
export const ADD_CUSTOMER = "/customer/";
export const ADD_CUSTOMER_FORM = "/customer/form";
export const GET_DATA_FROM_ZIPCODE = "/customer/zip-details/";
export const ADD_CUSTOMER_USER = "/customer/customer-user/";
export const GET_PARENT_CUSTOMER_DATA = "/user/auth/parent-customer";
export const GET_CUSTOMER_LIST = "/user/auth/customerList";
export const SWITCH_PARENT_CUSTOMER = "/user/auth/switch-user";
export const CUSTOMER_MARKUP = "/customer/markup";
export const CUSTOMER_MARKUP_AGENT = "/customer/markup/agent-markup/";
export const CUSTOMER_MARKUP_SERVICES = "/customer/markup/service-markup/";
export const CUSTOMER_CHARGES_ADDITIONALS_DATA = "/customer/charges/additional";
export const REMOVE_CUSTOMER_ADDITIONAL_CHARGES = "/customer/charges/removeAdditionalCharges";
export const GET_CUSTOMER_NOTIFICATION = "/customer/notification/";
export const UPDATE_CUSTOMER_NOTIFICATION = "/customer/notification/";
export const GET_CUSTOMER_EMAIL_NOTIFICATION = "/customer/email-notification/";

/***** Agent end points ******/
export const ADD_EDIT_AGENT = "/agent/";
export const REMOVE_AGENT_ADDITIONAL_CHARGES = "/agent/charges/removeAdditionalCharges";
export const AGENT_FOR_CUSTOMER_RATE = "/agent/customer-rate-agents";
export const GET_AGENT_TYPE = "/agent/agent-type";
export const GET_AGENT_SERVICE_LIST = "/agent/service";
export const SERVICE_FOR_CUSTOMER_RATE = "/agent/service/customer-rate-services";
export const GET_AGENT_DETAILS = "/agent/agent-rate";
export const GET_FSC_LOCATIONS = "/agent/fsc-location";
export const AGENT_HUB_DATA = "/agent/agent-hub/";
export const AGENT_HUB_FIRST_BY_AGENT = "/agent/agent-hub/first-hub-by-agent";
export const AGENT_HUB_FOR_CUSTOMER_RATE = "/agent/agent-hub/customer-rate-hubs";
export const AGENT_HUB_SERVICE_ZIP = "/agent/agent-hub/service-zip";
export const AGENT_HUB_CUSTOMER = "/agent/agent-hub/customer";
/**
 * Final Mile agent catalog/mapping for a given internal LTL agent.
 * GET  ?internalLtlAgentId=<id> → { allActiveFinalmileAgent, allActiveMapFinalmileAgent }
 * POST → body { internalAgentId, activeFinalmileAgentId[], inactiveFinalmileAgentId[] }
 */
export const FINAL_MILE_AGENT_LIST_FOR_LTL_AGENT = "/agent/internal-ltl-final-mile-agent";
export const GET_AGENT_NUMBER = "/agent/agent-number/"; // trailing slash — agent id appended
export const ORDER_STATUS = "/order/order-status";
export const GET_OTHER_CHARGE_LIST = "/order/other-charge/list";
/** PUT — saves the Track LTL handles for one order. */
export const SAVE_ORDER_TRACK_LTL = "/order/save-track-ltl";
/** GET — checks whether a BOL is already on file before Track LTL saves it. Append `?bol=<value>`. */
export const CHECK_TRACK_LTL_BOL = "/order/trackltl/checkbol";

/*** Report end points *****/
export const GET_REPORT_COLUMNS = "/report/column-list";
export const GET_REPORT_URL = "/report/reporturl";
export const REPORT_CUSTOMER_LIST = "/report/customer/list";

/***** Dispatch board end points ******/
export const DISPATCH_BOARD_ADD_NOTE = "/order/dispatch-board/note";
export const GET_DISPATCH_ACCOUNT_EXCEPTIONS = "/order/accounting-exception/list";

/***** External end points ******/
export const GET_CUSTOMER_KEY = "/external/v1/credential";
export const GET_AGENT_KEY = "/external/v1/generateagentcred";
export const REMOVE_AGENT_KEY = "/external/v1/deleteagentcred";

/***** Xcelerator end points ******/
export const GET_XCELERATOR_DATA = "/agent/xcelerator/";

/***** Resend end points ******/
export const RESEND_INVITATION_KEY = "/user/auth/resend-invitation";

/***** Account activation end points ******/
// Set the password for an invited-but-not-onboarded account and activate it.
// PUT, with the record id appended to the URL.
export const ACTIVATE_CUSTOMER = "/customer/activate/";
export const ACTIVATE_SALES_REP = "/customer/salesrep/activate/";
export const ACTIVATE_AGENT = "/customer/agent/activate/";

/***** Invoice End Points ******/
export const GET_SAVE_CUSTOMER_INVOICE_GROUPS_LIST = "/order/invoice-group";

export const GET_SAVE_ORDER_INVOICE_LIST = "/order/invoice";
export const GET_ORDER_INVOICE_ORDER_DATA = "/order/invoice/group-orders";
export const GET_ORDER_INVOICE_CALCULATION_DATA = "/order/invoice/calc";
export const GET_ALL_INVOICE_GROUP = "/order/invoice/allInvoiceGroup";
// History endpoints used by the invoice listing "Mail History" action.
// The invoice id is appended by the modal (`${apiUrl}/${id}`).
export const GET_INVOICE_EMAIL_HISTORY = "/order/invoice/email-history";
export const GET_INVOICE_EDI_HISTORY = "/order/invoice/email-history";

/***** Resend end points ******/
export const DASHBOARD_API = "/order/dashboard/kpis";

/***** Agent api end points ******/
export const ADD_LOGIN_DETAILS = "agent/clientCredential/loginCredential";
export const GET_AGENT_API_DETAILS = "agent/clientCredential/agentcredlist";
export const UPDATE_LOGIN_DETAILS = "/agent/clientCredential/updateAgentCred/";
export const AGENT_REQUEST_API = "/agent/agent-request";
export const AGENT_REQUEST_PERMISSION_API = "/agent/agent-request/permission";

/***** System configuration end points ******/
//#SERVICES_ENDPOINT
export const ADD_SERVICES = "/service/addNewService";
export const UPDATE_SERVICES = "/service/updateService/";
export const GET_SERVICES = "/service";

export const ADD_PACKAGE_TYPE = "service/packagetype/create";
export const UPDATE_PACKAGE_TYPE = "/service/packagetype/update/";

/***** Import end points ******/
export const IMPORT_ZIP = "import/zip";
export const IMPORT_ACTIVE_CUSTOMER = "import/hubactivecustomer";
export const IMPORT_AGENT_HUB = "import/agentHub";
export const IMPORT_AGENT = "import/agent";
export const IMPORT_MILE_ZONE = "import/hubmilezone";
export const IMPORT_WEIGHT_ZONE = "import/hubweightzone";
export const IMPORT_FSC_AGENT = "import/fscagentlist ";
export const IMPORT_FSC_AGENT_INTERNAL_LTL = "/import/fscagentlist/internaltl";
export const IMPORT_AGENT_RATE = "import/agentrateimport";
export const IMPORT_CUSTOMER_LIST = "/import/customer/";
export const IMPORT_CUSTOMER_RATE_LIST = "/import/customer-rate/";
export const IMPORT_CUSTOMER_FSC_LIST = "/import/fsccustomer/";
export const IMPORT_AGENT_ADDITIONAL_CHARGES =
  "/import/additionalcharges/agent";
export const IMPORT_CUSTOMER_ADDITIONAL_CHARGES =
  "/import/additionalcharges/customer";
export const IMPORT_SCAC = "/import/bulkscac";
export const DOWNLOAD_IMPORT_TEMPLATE = "/import/download-template";
/***** Phone Validation Api ******/
export const PHONE_VALIDATE_API = "/order/phone-validate";

/***** Saved Quotation Api ******/
export const SAVE_QUOTATION = "/order/order-quote/savedquotation";
export const GET_QUOTATION = "/order/order-quote/savequotationlist";
export const DELETE_QUOTATION = "/order/order-quote/deletesavedquotation";
export const SAVE_LTL_QUOTATION = "/order/order-quote/savedquotationforltl";

/***** Email Template Api ******/
export const ADD_EMAIL_TEMPLATE = "/service/emailTemplate/create";
export const GET_EMAIL_TEMPLATE_DETAILS = "/service/emailTemplate/getById";
export const UPDATE_EMAIL_TEMPLATE = "/service/emailTemplate/update";

/***** Static Data Api ******/
export const STATIC_DATA_API = "/user/static/data";
/***** Email Template Api ******/
export const INVOICE_DETAIL_EDIT = "/customer/invoiceedidetail/";

/**Bulk Upload Quote end point */
export const UPLOAD_BULK_QUOTE = "import/bulkquote/";
/**Bulk Quote Listing end point */
export const BULK_QUOTE_LISTING = "import/bulkquote/list?limit=2&page=2";
/**Bulk Upload Order end point */
export const UPLOAD_BULK_ORDER = "import/bulkorder/";

//**Customer agent hubs Active and inactive agent hub API */
export const GET_AGENT_HUB_FOR_CUSTOMER = "customer/agenthub?page=1&limit=100";

//**Customer active hubs active and inactive save API endpoint */

export const SAVE_INACTIVE_ACTIVE_HUBS = "customer/agenthub/active";

//**Customer LTL integrations GET  reuest for Listing of APIs */
export const LTL_API_KEY_LIST = "/order/ltlApikey/apiKeyList";

// ** agent and customer listing API
export const CUSTOMER_LIST_FOR_HUB = "/customer/customerlistforhub";
export const GET_INVOICE_GROUP_CUSTOMERS = "/customer/invoice-group-customers";

/***** Master Zip Code end points ******/
export const GET_MASTER_ZIP_CODE_LIST = "/service/master-zipcode";
export const ADD_MASTER_ZIP_CODE = "/service/master-zipcode/create";
export const UPDATE_MASTER_ZIP_CODE = "/service/master-zipcode/update/";
export const DELETE_MASTER_ZIP_CODE = "/service/master-zipcode/delete/";
export const BULK_DELETE_MASTER_ZIP_CODE = "/service/master-zipcode/delete";
export const IMPORT_MASTER_ZIP_CODE = "/import/masterservicezipcode";


/***** Rep Management (My Rep List) end points ******/
export const GET_REP_LIST = "/customer/salesrep/";
export const REP_DETAIL = "/customer/salesrep/"; // trailing slash — rep id appended for delete/active
export const ADD_REP = "/customer/salesrep";
export const ACTIVE_REP = "/customer/salesrep/active/"; // trailing slash — rep id appended
export const EDIT_REP = "/customer/salesrep/"; // trailing slash — rep id appended
export const GET_REP_BY_ID = "/customer/salesrep/"; // trailing slash — rep id appended
export const SALES_REP_EMAIL_EXIST = "/customer/salesrep/email-exist"; // ?email= → { exist: boolean }
export const GET_SALES_REP_MASTER = "/customer/salesrepmaster"; // combined rep types + commission structures + triggers
export const GET_REP_TYPES = "/customer/salesrepmaster/reptype";
export const GET_SALES_REP_CUSTOMERS = "/customer/salesrepmaster/getAllCustomerListForSalesRep";
export const GET_COMMISSION_STRUCTURES = "/customer/salesrepmaster/commissionStructure";
export const GET_COMMISSION_TRIGGERS = "/customer/salesrepmaster/commissionTrigger";
export const EXPORT_REPS = "/import/sales-rep/export";


// Location Endpoints
export const ADD_LOCATION_MAPPING = "/order/location-mapping";
export const GET_LOCATION_LISTING = "/order/location-mapping/tenant-location";
export const DELETE_LOCATION_MAPPING = "/order/location-mapping/"

// Audit Log Endpoints
export const GET_AUDIT_LOG_LIST = "/order/activity-log";

export const ADD_CC_EMAIL = "/service/communication-email/add"


// Region endpoints
export const ADD_REGION_ENDPOINTS = "/service/region/create"
export const UPDATE_REGION_ENDPOINTS = "/service/region/update/"
export const GET_REGION_LISTING = "/service/region"
export const GET_STATE_LISTING = "/service/region/states"
export const DELETE_REGION_ENDPOINT = "/service/region/delete/"

// FSC Location endpoints
export const GET_FSC_LOCATION_CONFIG = "/service/fsc-location"
export const UPDATE_FSC_LOCATION_PRICE = "/service/fsc-location/update"


// Export Endpoints
export const EXPORT_ORDERS = "/import/order/export"
export const EXPORT_INVOICE = "/import/invoice/export"
export const EXPORT_AGENTS = "/import/agent/export"
export const EXPORT_MASTER_AGENTS = "/import/master-agent/export"
export const EXPORT_CUSTOMERS = "/import/customer/export"
export const EXPORT_CUSTOMER_USERS = "/import/customer-user/export"
export const EXPORT_CUSTOMER_ITEMS = "/import/customer-item/export"
export const EXPORT_ADDRESS_BOOK = "/import/address-book/export"
export const EXPORT_SITE_USERS ="/import/site-user/export"
export const EXPORT_CUSTOMER_GROUPS="/import/customer-invoice-group/export"

// Order Status Endpoints
export const GET_STATUS_ENDPOINT = "/service/order-status/"
export const UPDATE_STATUS_ENDPOINT = "/service/order-status/update/"

// Customer Onward Api endpoints
export const UPDATE_ONWARD_API_DETAILS = "/customer/onwardapidetail/"

// Order Tracking endpoints
export const ORDER_TRACKING_SEARCH = "/order/order-tracking/trackingOrderStatusAccordingtoSelectedKey"
export const ORDER_TRACKING_DETAILS = "/order/order-tracking/"

// Accounting exception audit-log endpoint (append orderId + ?page&limit)
export const GET_ACCOUNTING_EXCEPTION_AUDIT_LOG = "/order/accounting-exception/audit-log/"
// View Exception (banner) single-table audit log — append orderId.
export const GET_VIEW_EXCEPTION_AUDIT_LOG = "/order/accounting-exception/accounting-exception-audit-log/"

// SCAC endpoints
export const GET_SCAC_LTL_CARRIER = "/service/scac/ltlCarrier"
// Helpdesk mailbox endpoints — live
export const GET_MAILBOXES = "/service/mailbox";
export const ADD_MAILBOX = "/service/mailbox/create";
/** GET one mailbox's settings: append `${mailboxId}`. */
export const MAILBOX_BY_ID = "/service/mailbox/";
/** PUT { groupId, showsAs?, ignoreOwnMail?, autoAcknowledge? } — append `${mailboxId}`; optional keys only when the API returned them. */
export const UPDATE_MAILBOX = "/service/mailbox/update/";
/** POST (no body) after `${MAILBOX_BY_ID}${mailboxId}` — re-runs SPF / DKIM / DMARC checks. */
export const MAILBOX_CHECK_AUTH_PATH = "/check-authentication";
export const GET_MAILBOX_BLOCKED_EMAILS = "/service/mailbox/blocked-email";
/** DELETE — append `${blockedEmailId}` to unblock that address. */
export const DELETE_MAILBOX_BLOCKED_EMAIL = "/service/mailbox/blocked-email/";

// Helpdesk groups & assignment endpoints — live
export const GET_HELPDESK_GROUPS = "/service/helpdesk-group";
export const ADD_HELPDESK_GROUP = "/service/helpdesk-group/create";
/** People who can be made group members (New Group, Add Member): ?page&limit&keyword → [{ id, name, email }]. */
export const GET_HELPDESK_UNASSIGNED_MEMBERS = "/service/helpdesk-group/members/unassigned";
/** Helpdesk lookup data: { timeZone: string[], iconOptions: [...] } (cached in Redux). */
export const GET_HELPDESK_STATIC_DATA = "/service/helpdesk-group/staticdata";
/** One group: append `${groupId}`, then one of the HELPDESK_GROUP_*_PATH suffixes below. */
export const HELPDESK_GROUP_BY_ID = "/service/helpdesk-group/";
/** GET a group's members. */
export const HELPDESK_GROUP_MEMBERS_PATH = "/members";
/** POST { memberIds } to add members. */
export const HELPDESK_GROUP_ADD_MEMBERS_PATH = "/members/add";
/** PUT { available } — append `${userId}`; availability is per group. */
export const HELPDESK_GROUP_MEMBER_AVAILABILITY_PATH = "/members/availability/";
/** PUT { isLead } — append `${userId}`; lead is per group. */
export const HELPDESK_GROUP_MEMBER_LEAD_PATH = "/members/lead/";
/** PUT { assignment, capPerMember }. */
export const HELPDESK_GROUP_ASSIGNMENT_CONFIG_PATH = "/assignment-config";
/** PUT (no body) — append `${userId}` to remove that member from the group. */
export const HELPDESK_GROUP_DELETE_MEMBER_PATH = "/members/delete/";

// Helpdesk SLA policy endpoints — placeholders until the backend contract lands
export const GET_SLA_POLICIES = "/service/helpdesk-sla";
export const UPDATE_SLA_POLICY_TARGET = "/service/helpdesk-sla/target/";
export const UPDATE_SLA_POLICY_ESCALATION = "/service/helpdesk-sla/escalation/";
export const GET_SLA_CLOCK_RULES = "/service/helpdesk-sla/clock-rules";

// Helpdesk business hours (calendar) endpoints — live
/** GET ?keyword&page&limit — the calendars, paged. */
export const GET_BUSINESS_HOURS = "/service/business-hours";
/** GET ?calendarId&page&limit&keyword — groups that can be put on a calendar (`calendarId` when editing one). */
export const GET_BUSINESS_HOURS_ELIGIBLE_GROUPS = "/service/business-hours/groups/eligible";
/** POST { name, timezone, groupIds, scheduleType, weeklyHours }. */
export const ADD_BUSINESS_HOURS = "/service/business-hours/create";
/** GET one calendar: append `${calendarId}` (and BUSINESS_HOURS_SET_DEFAULT_PATH to make it the default). */
export const BUSINESS_HOURS_BY_ID = "/service/business-hours/";
/** PUT (no body) after `${BUSINESS_HOURS_BY_ID}${calendarId}`. */
export const BUSINESS_HOURS_SET_DEFAULT_PATH = "/set-default";
/** PUT the same body as create — append `${calendarId}`. */
export const UPDATE_BUSINESS_HOURS = "/service/business-hours/update/";
// After `${BUSINESS_HOURS_BY_ID}${calendarId}`:
/** GET the members with individual hours; append `/${userId}` for one member. */
export const BUSINESS_HOURS_MEMBERS_PATH = "/members";
/** GET ?keyword&groupId — users who can be given individual hours (none configured yet). */
export const BUSINESS_HOURS_ELIGIBLE_MEMBERS_PATH = "/members/eligible";
/** POST { memberIds, groupId?, scheduleType, weeklyHours }. */
export const BUSINESS_HOURS_ADD_MEMBERS_PATH = "/members/add";
/** PUT { scheduleType, weeklyHours } — append `${userId}`. */
export const BUSINESS_HOURS_UPDATE_MEMBER_PATH = "/members/update/";
/** PUT (no body) — append `${userId}` to remove that member's individual hours. */
export const BUSINESS_HOURS_DELETE_MEMBER_PATH = "/members/delete/";
/** GET ?page&limit — the calendar's holidays; DELETE with `/${holidayId}` removes one. */
export const BUSINESS_HOURS_HOLIDAYS_PATH = "/holidays";
/** POST { name, date: "YYYY-MM-DD" }. */
export const BUSINESS_HOURS_ADD_HOLIDAY_PATH = "/holidays/create";
/**
 * Append `${groupId}`: one group's business hours on the calendar.
 * GET → { weeklyHours, isOverride }; PUT { isCustomBusinessHrs, weeklyHours } saves them.
 */
export const BUSINESS_HOURS_GROUP_PATH = "/group/";

// Helpdesk signatures & sending endpoints — live (Sending identities come from GET_MAILBOXES).
// A lane's content is lines joined with `<br>`, fields written as `{{<insert-field id>}}`.
/** GET ?limit&page — the users with a signature: [{ id, userId, name, email, team, …Content, …Preview, updatedAt }]. */
export const GET_SIGNATURES = "/service/signature";
/** GET one signature (its lanes' content and previews): append `${signatureId}`. */
export const SIGNATURE_BY_ID = "/service/signature/";
/** GET — the fields a lane can hold: [{ id, name }]. */
export const GET_SIGNATURE_INSERT_FIELDS = "/service/signature/insert-fields";
/** GET ?page&limit&keyword (+ groupId) — users a signature can be created for: [{ id, name, email }]. */
export const GET_SIGNATURE_ELIGIBLE_USERS = "/service/signature/eligible-users";
/** POST { userId, customerLaneSignatureContent, agentLaneSignatureContent } → each lane's preview as HTML. */
export const PREVIEW_SIGNATURE = "/service/signature/preview";
/** POST { userId, customerLaneSignatureContent, agentLaneSignatureContent }. */
export const ADD_SIGNATURE = "/service/signature/create";
/** PUT only the changed lane(s) — append `${signatureId}`. */
export const UPDATE_SIGNATURE = "/service/signature/update/";

// Helpdesk notification settings endpoints — live
/** GET — every notification setting, in the API's order (no paging). */
export const GET_NOTIFICATION_SETTINGS = "/service/notification-setting";
/** PUT { id, inShift, email } — one setting per call. */
export const UPDATE_NOTIFICATION_SETTING = "/service/notification-setting/update";

// Helpdesk ticket statuses & priorities endpoints — live
/** GET — every ticket status (alphabetical, from the API). */
export const GET_TICKET_STATUSES = "/service/ticket-status";
/** POST { name, color }. */
export const CREATE_TICKET_STATUS = "/service/ticket-status/create";
/** PUT { name, color } — append `${statusId}`. */
export const UPDATE_TICKET_STATUS = "/service/ticket-status/update/";
/** PUT, no body — append `${statusId}`. Makes it the default (open) status; the API clears the previous one. */
export const SET_DEFAULT_OPEN_TICKET_STATUS = "/service/ticket-status/setDefaultOpen/";
/** GET — every ticket priority (newest first, from the API). */
export const GET_TICKET_PRIORITIES = "/service/ticket-priority";
/** POST { label, icon, color }. */
export const CREATE_TICKET_PRIORITY = "/service/ticket-priority/create";
/** PUT { label, icon, color } — append `${priorityId}`. */
export const UPDATE_TICKET_PRIORITY = "/service/ticket-priority/update/";
/** PUT, no body — append `${priorityId}`. Makes it the default priority; the API clears the previous one. */
export const SET_DEFAULT_TICKET_PRIORITY = "/service/ticket-priority/setDefault/";

// Helpdesk tags endpoints — placeholders until the backend contract lands
export const GET_TAG_IMPORT_RULES = "/service/helpdesk-tag/import-rules";
export const GET_HELPDESK_TAGS = "/service/helpdesk-tag";
export const RENAME_HELPDESK_TAG = "/service/helpdesk-tag/rename/";
export const MERGE_HELPDESK_TAGS = "/service/helpdesk-tag/merge";

// Helpdesk canned responses (System Configuration) — the list shares
// GET_HELPDESK_CANNED_RESPONSES with the order composer. Placeholders until the backend contract lands.
export const UPDATE_HELPDESK_CANNED_RESPONSE = "/service/helpdesk/canned-responses/update/";
export const GET_CANNED_RESPONSE_FIELDS = "/service/helpdesk/canned-responses/fields";
export const GET_CANNED_PREVIEW_SAMPLE = "/service/helpdesk/canned-responses/preview-sample";

// Helpdesk ticket queue (helpdesk-service)
export const GET_TICKET_QUEUE = "/helpdesk/ticket-queue";
// Communications › Unassigned (KAN-1330–1333)
export const GET_QUEUE_TICKETS = "/helpdesk/tickets";
export const GET_QUEUE_OPTIONS = "/helpdesk/tickets/options";
export const SEARCH_QUEUE_ORDERS = "/helpdesk/tickets/order-search";
// GET → { id, name } of the Exception group, or null (Communications › Exceptions shows only while it exists)
export const GET_EXCEPTION_GROUP = "/helpdesk/tickets/exception-group";
// GET `${SEARCH_TICKET_RECIPIENTS}?q=&kind=user|agent` → To / CC suggestions (Communications ticket screen)
export const SEARCH_TICKET_RECIPIENTS = "/helpdesk/tickets/recipient-search";
export const UPDATE_QUEUE_TICKET = "/helpdesk/tickets/update/";
// Saved column choice for list tables (read with ?tableName=…; saved by ColumnFilterModal)
export const GET_TABLE_FILTER_LIST = "/order/filter/list";
// Helpdesk conversation endpoints (order Conversations tab). Live in helpdesk-service: conversations,
// unread count, thread update / open / read, notes and activity. The rest are placeholders until the
// backend contract lands.
export const GET_ORDER_CONVERSATIONS = "/helpdesk/order-conversations/";
// GET `${GET_TICKET_CONVERSATION}${ticketId}` → one ticket for the Communications ticket screen (KAN-1334–1340)
export const GET_TICKET_CONVERSATION = "/helpdesk/ticket-conversation/";
// GET `${GET_ORDER_CONVERSATIONS}${orderId}${ORDER_CONVERSATIONS_UNREAD_SUFFIX}`
export const ORDER_CONVERSATIONS_UNREAD_SUFFIX = "/unread-count";
export const UPDATE_CONVERSATION_THREAD = "/helpdesk/thread/update/";
export const OPEN_CONVERSATION_THREAD = "/helpdesk/thread/open/";
// Presence (who is viewing / replying, KAN-1273) is a socket.io connection on this path, not a REST call
export const PRESENCE_SOCKET_PATH = "/helpdesk/socket.io";
// GET `${LOOKUP_TICKET}${ticketNumber}` → { ticketId, orderId, … } (master search, KAN-1320)
export const LOOKUP_TICKET = "/helpdesk/ticket-lookup/";
export const MARK_CONVERSATION_READ = "/helpdesk/thread/read/";
export const GET_CONVERSATION_ACTIVITY = "/helpdesk/thread/activity/";
// GET `${DOWNLOAD_CONVERSATION_ATTACHMENT}${attachmentId}` → the file (binary)
export const DOWNLOAD_CONVERSATION_ATTACHMENT = "/helpdesk/thread/attachment/";
// POST `${SEND_CONVERSATION_EMAIL}${ticketId}` → { thread, sent, failureReason } (KAN-1321 / 1323)
export const SEND_CONVERSATION_EMAIL = "/helpdesk/thread/send/";
// POST `${CREATE_CONVERSATION_THREAD}${orderId}` → { thread, sent, failureReason } ("New Thread" on the order)
export const CREATE_CONVERSATION_THREAD = "/helpdesk/thread/new/";
export const ADD_CONVERSATION_NOTE = "/helpdesk/thread/note/";
export const MOVE_CONVERSATION_EMAIL = "/service/helpdesk/email/move-chain/";
export const SPLIT_CONVERSATION_EMAIL = "/service/helpdesk/email/split/";
export const FILE_EMAIL_ATTACHMENT_TO_ORDER = "/service/helpdesk/attachment/file-to-order/";
export const DRAFT_CONVERSATION_REPLY = "/service/helpdesk/thread/draft-reply/";
export const GET_HELPDESK_CANNED_RESPONSES = "/service/helpdesk/canned-responses";
